import { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../../App";
import useInvoke from "../../Tools/Invoker";
import GetOiler from "../Tools/OilerGetOiler";
import toast from "react-hot-toast";
import CheckToken from "../../_Login/CheckToken";
import TestSave from "../Tools/OilerTestSave";
import ConfigurationSave from "../Tools/OilersConfigurationSave";

const OilerConfiguration = () => {
    const [user, setUser] = useContext(UserContext);
    const navigate = useNavigate();
    const { id } = useParams();
    CheckToken(user["id"], user["token"]).then((result) => { if (!result) { setUser({}); navigate("/Login"); } });

    const [allowedDeviation, setAllowedDeviation] = useState(15);

    const [oiler, setOiler] = useState({});
    const [configuration, setConfiguration] = useState({});
    const [headers, setHeaders] = useState([]);
    const [tests, setTests] = useState([]);

    const response88 = useInvoke("WebApps", "88", { "@ConfigID": id });
    const response93 = useInvoke("WebApps", "93", { "@ConfigID": id });
    const response94 = useInvoke("WebApps", "94", { "@ConfigID": id });

    useEffect(() => {
        if (response88.data.payload !== undefined) {
            const myConfig = JSON.parse(response88.data.payload).data;

            let numBlanksString = "";

            if (myConfig[0][8] == 1) {
                numBlanksString = "Single";
            } else if (myConfig[0][8] == 2) {
                numBlanksString = "Double";
            } else {
                numBlanksString = "Unknown";
            }

            let obj = {
                ConfigID: myConfig[0][0],
                OilID: myConfig[0][1],
                OilName: myConfig[0][2],
                CustomerBlankNum: myConfig[0][3],
                Length: myConfig[0][4],
                Width: myConfig[0][5],
                Speed: myConfig[0][6],
                Coverage: myConfig[0][7],
                NumberOfBlanks: myConfig[0][8],
                OilTemp: myConfig[0][9],
                AsShipped: myConfig[0][10],
                OilerID: myConfig[0][11],
                OilDescription: myConfig[0][12],
                OilViscosity: myConfig[0][13],
                NumberofBlanksString: numBlanksString
            };
            setConfiguration(obj);
        }

        if (response93.data.payload !== undefined) {
            const myHeaders = JSON.parse(response93.data.payload).data;
            const headersList = myHeaders.map(header => ({
                HeaderID: header[0],
                ConfigID: header[1],
                Location: header[2],
                FlowSP: header[3],
                OuterBar: {
                    SprayVoltage: header[4],
                    RestingVoltage: header[5],
                    IdleVoltage: header[6]
                },
                CenterBar: {
                    SprayVoltage: header[7],
                    RestingVoltage: header[8],
                    IdleVoltage: header[9]
                },
                Nozzle: {
                    SprayVoltage: header[10],
                    RestingVoltage: header[11],
                    IdleVoltage: header[12]
                },
                Boost: {
                    SprayVoltage: header[13],
                    RestingVoltage: header[14],
                    IdleVoltage: header[15]
                },
                HighVoltage: {
                    OnTime: header[16],
                    OffTime: header[17]
                },
                NozzleTimes: {
                    OnTime: header[18],
                    OffTime: header[19]
                }
            }));
            setHeaders(headersList);
        }

        if (response94.data.payload !== undefined) {
            const myTests = JSON.parse(response94.data.payload).data;
            let testsList = [];

            myTests.forEach(test => {
                let obj = {
                    TestID: test[0],
                    ConfigID: test[1],
                    TestNum: test[2],
                    BlankNum: test[3],
                    TopValue: test[4],
                    BottomValue: test[5],
                    Position: test[6]
                };

                testsList.push(obj);
            });

            // Sort the tests
            testsList.sort((a, b) => {
                if (a.BlankNum !== b.BlankNum) {
                    return a.BlankNum - b.BlankNum;
                } else if (a.Position !== b.Position) {
                    return a.Position.localeCompare(b.Position);
                } else {
                    return a.TestNum - b.TestNum;
                }
            });

            setTests(testsList);
        }

    }, [response88.data.payload, response93.data.payload, response94.data.payload]);

    useEffect(() => {
        if (configuration["OilerID"] !== undefined) {
            GetOiler(configuration["OilerID"]).then((result) => {
                if (result !== undefined) {
                    const myOiler = JSON.parse(result.payload).data;
                    let obj = {
                        OilerID: myOiler[0][0],
                        JobNum: myOiler[0][1],
                        SiteAddressID: myOiler[0][2],
                        NumTestPoints: myOiler[0][3],
                        InFeedSensorDistance: myOiler[0][4],
                        CustomerID: myOiler[0][5],
                        CustomerName: myOiler[0][6],
                        CustomerAddress: myOiler[0][7],
                        CityStateZip: myOiler[0][8],
                        SiteName: myOiler[0][9],
                        SiteAddressName: myOiler[0][10],
                        SiteCityStateZip: myOiler[0][11],
                        DateCreated: myOiler[0][12],
                        CreatedByID: myOiler[0][13],
                        CreatedByName: myOiler[0][14],
                    };
                    setOiler(obj);
                }
            });
        }

    }, [configuration]);

    const handleNewTestSet = () => {

        /*

            -Number of tests per blank = number of test points from Oiler data
            -If number of blanks is 1, position is center
            -If number of blanks is 2, positions are left and right
            -Blank numbers 5 and 6 are tested for each position
            -Sample data for oiler with 4 test points and 1 blank below
            
            Blank #	Test #	Top (mg/sqft)	Bottom (mg/sqft)
              5	      1	      92 (-8.0)	      102 (+2.0)
              5	      2	      97 (-3.0)	      95 (-5.0)
              5	      3	      103 (+3.0)	  107 (+7.0)
              5	      4	      95 (-5.0)	      91 (-9.0)
              6	      1	      100 (0.0)	      100 (0.0)
              6	      2	      102 (+2.0)	  98 (-2.0)
              6	      3	      94 (-6.0)	      109 (+9.0)
              6	      4	      99 (-1.0)	      93 (-7.0)

        */

        let testsList = [];
        let numBlanks = configuration.NumberOfBlanks;
        let numTestPoints = oiler.NumTestPoints;
        let positions = numBlanks == 1 ? ["Center"] : ["Left", "Right"];

        for (let blankNum of [5, 6]) {
            for (let i = 1; i <= numBlanks; i++) {
                for (let j = 1; j <= numTestPoints; j++) {
                    let obj = {
                        TestID: "",
                        ConfigID: configuration.ConfigID,
                        TestNum: j,
                        BlankNum: blankNum,
                        TopValue: 0,
                        BottomValue: 0,
                        Position: positions[i - 1]
                    };
                    testsList.push(obj);
                }
            }
        }

        let breakpoint = "";
        // Send testsList to API in sequence
        testsList.forEach((test, index) => {

            TestSave(test.TestID, test.ConfigID, test.TestNum, test.BlankNum, test.TopValue, test.BottomValue, test.Position).then((result) => {
                if (result.success) {
                    if (index == testsList.length - 1) {
                        toast.success("New test set created successfully!");
                        setTests(testsList);
                    }
                }
                else {
                    toast.error("Failed to create new test set");
                }
            });

        });

    };

    const handleUpdateConfiguration = () => {

        let asShipped = document.getElementById("input_asshipped").value;

        if (asShipped == "") {
            toast.error("Please select an option for 'As Shipped'");
            return;
        }

        //ConfigurationSave(configid, oilerid, oilid, customerblanknum, length, width, speed, coverage, numofblanks, oiltemp, asshipped)

        // let configObj = {
        //     ConfigID: configuration.ConfigID,
        //     OilerID: configuration.OilerID,
        //     OilID: configuration.OilID,
        //     CustomerBlankNum: configuration.CustomerBlankNum,
        //     Length: configuration.Length,
        //     Width: configuration.Width,
        //     Speed: configuration.Speed,
        //     Coverage: configuration.Coverage,
        //     NumberOfBlanks: configuration.NumberOfBlanks,
        //     OilTemp: configuration.OilTemp,
        //     AsShipped: asShipped
        // }

        ConfigurationSave(
            configuration.ConfigID,
            configuration.OilerID,
            configuration.OilID,
            configuration.CustomerBlankNum,
            configuration.Length,
            configuration.Width,
            configuration.Speed,
            configuration.Coverage,
            configuration.NumberOfBlanks,
            configuration.OilTemp,
            asShipped
        ).then((result) => {

            if (result.success) {
                toast.success("Configuration updated successfully!");
            }
            else {
                toast.error("Failed to update configuration");
            }
        });
    };

    const handleUpdateHeaders = () => {
        console.log("Coming soon");
        toast("Coming soon");
    };

    const handleIncrement = (increment) => {
        setAllowedDeviation(prev => Math.max(0, prev + increment));  // Ensure allowedDeviation doesn't go below 0
    };

    document.title = `Config ${id}`;
    return (
        <>
            {user.email &&
                <div className="container body-content" style={{ marginTop: "25px" }}>

                    <div style={{ display: "flex", flexDirection: "row", marginBottom: "8px", justifyContent: "space-between" }}>
                        <Link to={`/Oilers/Details/${oiler["OilerID"]}`} className="btn btn-default" style={{ marginRight: "4px", width: "auto" }}>Back</Link>
                        <Link to={`/Oilers/Configuration/${id}/Print`} className="btn btn-info" style={{ width: "auto" }}>Print</Link>
                    </div>

                    <h2>Configuration ID #{configuration["ConfigID"]} for Oiler {oiler.JobNum} - {oiler.CustomerID}</h2>

                    {/* Oiler Data */}
                    <div className="card mb-4">
                        <div className="card-header" style={{ fontSize: "20px", backgroundColor: "#158cba", color: "var(--bs-light)" }}>
                            Oiler Data
                        </div>
                        <div className="card-body">
                            <div className="d-flex flex-row">
                                <table className="table table-bordered mx-2" style={{ width: "50%" }}>
                                    <tbody >
                                        <tr>
                                            <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}>Oiler ID</th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{oiler.OilerID}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}>Job Number</th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{oiler.JobNum}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}>JB Customer ID</th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{oiler.CustomerID}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}>Customer Name</th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{oiler.CustomerName}</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table className="table table-bordered mx-2" style={{ width: "50%" }}>
                                    <tbody>
                                        <tr>
                                            <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}>Date Created</th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{oiler.DateCreated}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}>Created By</th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{oiler.CreatedByName}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}># Test Points</th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{oiler.NumTestPoints}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}>Infeed Sensor Distance <span style={{ color: "var(--bs-secondary)" }}>(in)</span></th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{oiler.InFeedSensorDistance}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    {/* Configuration Data */}
                    <div className="card mb-4">
                        <div className="card-header" style={{ fontSize: "20px", backgroundColor: "#158cba", color: "var(--bs-light)" }}>
                            Configuration Data
                        </div>
                        <div className="card-body">
                            <div className="d-flex flex-row">
                                <table className="table table-bordered mx-2" style={{ width: "50%" }}>
                                    <tbody>
                                        {/* 
                                        <tr>
                                            <th scope="row">Oil ID</th>
                                            <td style={{textAlign: "center", verticalAlign: "middle"}}>{configuration.OilID}</td>
                                        </tr> 
                                        */}

                                        {/* <tr>
                                            <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}># Blanks</th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{configuration.NumberOfBlanks}</td>
                                        </tr> */}
                                        <tr>
                                            <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}># Blanks</th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{configuration.NumberofBlanksString}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}>Customer Blank #</th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{configuration.CustomerBlankNum}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}>Length <span className="text-secondary">(mm)</span></th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{configuration.Length}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}>Width <span className="text-secondary">(mm)</span></th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{configuration.Width}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}>Speed <span style={{ color: "var(--bs-secondary)" }}>(fpm)</span></th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{configuration.Speed}</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table className="table table-bordered mx-2" style={{ width: "50%" }}>
                                    <tbody>
                                        <tr>
                                            <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}>Coverage Target <span style={{ color: "var(--bs-secondary)" }}>(mg/sqft)</span></th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{configuration.Coverage}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}>Oil Name</th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{configuration.OilName}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}>Oil Viscosity <span style={{ color: "var(--bs-secondary)" }}>(cSt)</span></th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{configuration.OilViscosity}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}>Oil Temp <span style={{ color: "var(--bs-secondary)" }}>(°C)</span></th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{configuration.OilTemp}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" style={{ backgroundColor: "var(--bs-gray-300)" }}>Oil Description</th>
                                            <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{configuration.OilDescription}</td>
                                        </tr>

                                    </tbody>
                                </table>

                            </div>

                            <div style={{ width: "100%", display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center" }}>

                                <div style={{ marginLeft: "8px", color: "var(--bs-orange)", fontWeight: "bold" }}>As Shipped?&nbsp;</div>
                                <div style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-light)"}}>
                                    {configuration && configuration.AsShipped != undefined && (
                                        <select id="input_asshipped" className="form-select" style={{ fontSize: "16px", minWidth: "100%" }} defaultValue={configuration.AsShipped == "True" ? "True" : "False"} onChange={handleUpdateConfiguration}>
                                            <option value="">Select Option</option>
                                            <option value="True">Yes</option>
                                            <option value="False">No</option>
                                        </select>
                                    )}

                                </div>
                            </div>

                        </div>
                    </div>

                    {/* Header Data */}
                    <div className="card mb-4">
                        <div className="card-header" style={{ fontSize: "20px", backgroundColor: "#158cba", color: "var(--bs-light)" }}>
                            Headers
                        </div>
                        <div className="card-body">

                            <div className="alert alert-info" role="alert">
                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                    <span>(Information about headers will go here)</span>
                                </div>
                            </div>

                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th style={{ backgroundColor: "var(--bs-gray-500)" }}>Location</th>
                                        <th style={{ backgroundColor: "var(--bs-gray-500)" }}>Flow SP <span style={{ color: "var(--bs-secondary)" }}>(cc/min)</span></th>
                                        <th style={{ backgroundColor: "var(--bs-gray-500)" }}>Outer Bar Voltage <span style={{ color: "var(--bs-secondary)" }}>(kV)</span></th>
                                        <th style={{ backgroundColor: "var(--bs-gray-500)" }}>Center Bar Voltage <span style={{ color: "var(--bs-secondary)" }}>(kV)</span></th>
                                        <th style={{ backgroundColor: "var(--bs-gray-500)" }}>Nozzle Voltage <span style={{ color: "var(--bs-secondary)" }}>(kV)</span></th>
                                        <th style={{ backgroundColor: "var(--bs-gray-500)" }}>Boost Voltage <span style={{ color: "var(--bs-secondary)" }}>(kV)</span></th>
                                        <th style={{ backgroundColor: "var(--bs-gray-500)" }}>High Voltage <span style={{ color: "var(--bs-secondary)" }}>(ms)</span></th>
                                        <th style={{ backgroundColor: "var(--bs-gray-500)" }}>Nozzle Times <span style={{ color: "var(--bs-secondary)" }}>(ms)</span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {headers.map((header, index) => (
                                        <tr key={index}>
                                            <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{header.Location}</td>
                                            <td style={{ textAlign: "center", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>{header.FlowSP}</td>
                                            <td style={{ textAlign: "left", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>
                                                {header.Location == "Lower"
                                                    ? (
                                                        <i>-</i>
                                                    )
                                                    : (
                                                        <>
                                                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                                <span>Spray: </span>
                                                                <span>{header.OuterBar.SprayVoltage}</span>
                                                            </div>

                                                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                                <span>Resting: </span>
                                                                <span>{header.OuterBar.RestingVoltage}</span>
                                                            </div>

                                                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                                <span>Idle: </span>
                                                                <span>{header.OuterBar.IdleVoltage}</span>
                                                            </div>
                                                        </>
                                                    )
                                                }
                                            </td>
                                            <td style={{ textAlign: "left", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>
                                                {header.Location == "Lower"
                                                    ? (
                                                        <i>-</i>
                                                    )
                                                    : (
                                                        <>
                                                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                                <span>Spray: </span>
                                                                <span>{header.CenterBar.SprayVoltage}</span>
                                                            </div>

                                                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                                <span>Resting: </span>
                                                                <span>{header.CenterBar.RestingVoltage}</span>
                                                            </div>

                                                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                                <span>Idle: </span>
                                                                <span>{header.CenterBar.IdleVoltage}</span>
                                                            </div>
                                                        </>
                                                    )
                                                }

                                            </td>
                                            <td style={{ textAlign: "left", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>

                                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                    <span>Spray: </span>
                                                    <span>{header.Nozzle.SprayVoltage}</span>
                                                </div>

                                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                    <span>Resting: </span>
                                                    <span>{header.Nozzle.RestingVoltage}</span>
                                                </div>

                                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                    <span>Idle: </span>
                                                    <span>{header.Nozzle.IdleVoltage}</span>
                                                </div>

                                            </td>
                                            <td style={{ textAlign: "left", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>
                                                {header.Location == "Upper"
                                                    ? (
                                                        <i>-</i>
                                                    )
                                                    : (
                                                        <>
                                                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                                <span>Spray: </span>
                                                                <span>{header.Boost.SprayVoltage}</span>
                                                            </div>

                                                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                                <span>Resting: </span>
                                                                <span>{header.Boost.RestingVoltage}</span>
                                                            </div>

                                                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                                <span>Idle: </span>
                                                                <span>{header.Boost.IdleVoltage}</span>
                                                            </div>
                                                        </>
                                                    )
                                                }

                                            </td>
                                            <td style={{ textAlign: "left", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>

                                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                    <span>On Time: </span>
                                                    <span>{header.HighVoltage.OnTime}</span>
                                                </div>

                                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                    <span>Off Time: </span>
                                                    <span>{header.HighVoltage.OffTime}</span>
                                                </div>

                                            </td>
                                            <td style={{ textAlign: "left", verticalAlign: "middle", backgroundColor: "var(--bs-gray-300)" }}>

                                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                    <span>On Time: </span>
                                                    <span>{header.NozzleTimes.OnTime}</span>
                                                </div>

                                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                    <span>Off Time: </span>
                                                    <span>{header.NozzleTimes.OffTime}</span>
                                                </div>

                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div >

                    {/* Test Data */}
                    <div style={{ display: "flex", flexDirection: "row", width: "100%", justifyContent: "center" }}>
                        {['Left', 'Center', 'Right'].map((position, index) => {
                            const positionTests = tests.filter(test => test.Position == position);
                            return positionTests.length > 0 && (
                                <div key={index} style={{ display: "flex", flexDirection: "row", justifyContent: "center", width: "48%", margin: "1%" }}>
                                    <div className="card mb-4" style={{ width: "100%" }}>
                                        <div className="card-header" style={{ fontSize: "20px", backgroundColor: "#158cba", color: "var(--bs-light)" }}>{`${position} Tests`}</div>
                                        <div className="card-body">
                                            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                                <tbody>
                                                    <tr style={{ fontSize: "18px" }}>
                                                        <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: "left", backgroundColor: "var(--bs-gray-300)" }}>Coverage Target:</td>
                                                        <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: "center", fontWeight: "bold", color: "var(--bs-primary)", backgroundColor: "var(--bs-gray-300)" }}>
                                                            {configuration.Coverage} mg/sqft
                                                        </td>
                                                    </tr>
                                                    <tr style={{ fontSize: "16px" }}>
                                                        <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: "left", backgroundColor: "var(--bs-gray-300)" }}>Acceptable Tolerance:</td>
                                                        <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: "center", fontWeight: "bold", color: "var(--bs-danger)", backgroundColor: "var(--bs-gray-300)" }}>
                                                            <button className="btn" onClick={() => handleIncrement(-1)} style={{ color: "var(--bs-secondary)", opacity: "0.2" }}><span> - </span></button>
                                                            {allowedDeviation} mg/sqft
                                                            <button className="btn" onClick={() => handleIncrement(1)} style={{ color: "var(--bs-secondary)", opacity: "0.2" }}><span> + </span></button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th style={{ textAlign: "center" }}>Blank #</th>
                                                        <th style={{ textAlign: "center" }}>Test #</th>
                                                        <th style={{ textAlign: "center" }}>Top <span style={{ color: "var(--bs-secondary)" }}>(mg/sqft)</span></th>
                                                        <th style={{ textAlign: "center" }}>Bottom <span style={{ color: "var(--bs-secondary)" }}>(mg/sqft)</span></th>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {positionTests.map((test, index) => {
                                                        const topDeviation = (test.TopValue - configuration.Coverage).toFixed(1);
                                                        const bottomDeviation = (test.BottomValue - configuration.Coverage).toFixed(1);
                                                        const topColor = Math.abs(topDeviation) > allowedDeviation ? "var(--bs-danger)" : "var(--bs-success)";
                                                        const bottomColor = Math.abs(bottomDeviation) > allowedDeviation ? "var(--bs-danger)" : "var(--bs-success)";

                                                        return (
                                                            <tr key={index} title={`TestID: ${test.TestID}`}>
                                                                <td style={{ textAlign: "center", backgroundColor: test.BlankNum % 2 === 0 ? "var(--bs-gray-100)" : "var(--bs-gray-200)" }}>{test.BlankNum}</td>
                                                                <td style={{ textAlign: "center", backgroundColor: test.BlankNum % 2 === 0 ? "var(--bs-gray-100)" : "var(--bs-gray-200)" }}>{test.TestNum}</td>
                                                                <td style={{ textAlign: "center", backgroundColor: test.BlankNum % 2 === 0 ? "var(--bs-gray-100)" : "var(--bs-gray-200)" }}>
                                                                    <b>{test.TopValue}</b> (
                                                                    <span style={{ color: topColor }}>
                                                                        {topDeviation > 0 ? `+${topDeviation}` : topDeviation}
                                                                    </span>)
                                                                </td>
                                                                <td style={{ textAlign: "center", backgroundColor: test.BlankNum % 2 === 0 ? "var(--bs-gray-100)" : "var(--bs-gray-200)" }}>
                                                                    <b>{test.BottomValue}</b> (
                                                                    <span style={{ color: bottomColor }}>
                                                                        {bottomDeviation > 0 ? `+${bottomDeviation}` : bottomDeviation}
                                                                    </span>)
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", marginBottom: "8px" }}>
                        {tests.length == 0 ? (
                            <button className="btn btn-secondary" onClick={handleNewTestSet} style={{ width: "66%", margin: "auto" }}>
                                Create New Test Set
                            </button>
                        )
                            : (
                                <Link to={`/Oilers/Configuration/${id}/Tests`} className="btn btn-info" style={{ width: "66%", margin: "auto" }}>
                                    Edit Tests
                                </Link>
                            )}
                    </div>

                    <div style={{ display: "flex", flexDirection: "row", marginBottom: "8px", justifyContent: "space-between" }}>
                        <Link to={`/Oilers/Details/${oiler["OilerID"]}`} className="btn btn-default" style={{ marginRight: "4px", width: "auto" }}>Back</Link>
                    </div>

                </div >
            }
        </>
    );
};

export default OilerConfiguration;
